import moment from 'moment';

const TWITTER_MAX = 280;

export function getDefaultSharePageUrl() {
  if (typeof window === 'undefined') return '';
  return window.location.href;
}

/**
 * Plain text used for clipboard and share intents.
 */
export function formatMessageShareText(message, { pageUrl } = {}) {
  if (!message?.content) return '';

  const url = pageUrl ?? getDefaultSharePageUrl();
  const time = message.created_at
    ? moment(message.created_at).format('MMM D, YYYY h:mm A')
    : '';

  if (message.role === 'assistant') {
    const askedBy = message.triggered_by?.name;
    const header = askedBy
      ? `Assistant (reply to ${askedBy})${time ? ` · ${time}` : ''}`
      : `Assistant${time ? ` · ${time}` : ''}`;
    return [header, '', message.content, '', '— Market Finder Team Assistant', url]
      .filter(Boolean)
      .join('\n')
      .trim();
  }

  const name = message.user?.name || 'Team member';
  const header = `${name}${time ? ` · ${time}` : ''}`;
  return [header, '', message.content, '', '— Market Finder Team Assistant', url]
    .filter(Boolean)
    .join('\n')
    .trim();
}

export function buildShareLinks(text, { subject, pageUrl } = {}) {
  const body = (text || '').trim();
  const url = pageUrl ?? getDefaultSharePageUrl();
  const encodedBody = encodeURIComponent(body);
  const encodedSubject = encodeURIComponent(subject || 'Team assistant message');
  const encodedUrl = encodeURIComponent(url);
  const tweetText = body.length > TWITTER_MAX ? `${body.slice(0, TWITTER_MAX - 1)}…` : body;

  return {
    whatsapp: `https://wa.me/?text=${encodedBody}`,
    email: `mailto:?subject=${encodedSubject}&body=${encodedBody}`,
    twitter: `https://twitter.com/intent/tweet?text=${encodeURIComponent(tweetText)}`,
    facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}&quote=${encodedBody}`,
    linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`,
  };
}

export async function copyTextToClipboard(text) {
  const value = (text || '').trim();
  if (!value) return false;

  if (navigator.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(value);
      return true;
    } catch {
      /* fallback below */
    }
  }

  try {
    const textarea = document.createElement('textarea');
    textarea.value = value;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'fixed';
    textarea.style.left = '-9999px';
    document.body.appendChild(textarea);
    textarea.select();
    const ok = document.execCommand('copy');
    document.body.removeChild(textarea);
    return ok;
  } catch {
    return false;
  }
}

export function openShareUrl(url) {
  if (!url) return;
  window.open(url, '_blank', 'noopener,noreferrer');
}
